/* ============================================================
   FetchBall — ofertas y pagos SEPARADOS (solo se carga en la página de FetchBall)

   1) Pago con tarjeta: va directo a un pago nuevo con EXACTAMENTE la cantidad
      elegida y el código del 6 % de ESE paquete (TARJETA6-FB1/2/3). Antes de
      salir se vacía el carrito y se deja una marca para saber que fue a pagar.
   2) Al volver de ese intento (con "atrás" o entrando de nuevo): el carrito se
      vacía y se quitan los códigos; si la página estaba congelada se recarga,
      así Releasit arranca limpio (sin doble envío ni precios mezclados).
   3) En una visita normal NO se toca el carrito (Releasit lo usa): solo se
      quitan los códigos de descuento pegados.
   4) Antes de abrir el formulario contraentrega (Releasit) se quitan los códigos
      del carrito: el 6 % de tarjeta NUNCA llega a un pedido contraentrega.
   ============================================================ */
(function () {
  if (window.__fbOfertas) return;
  window.__fbOfertas = true;

  var JSON_H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var MARCA = 'fbVolviendoDeTarjeta';

  function boton() { return document.querySelector('[data-fb-tarjeta]'); }

  function leerCarrito() {
    return fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function quitarCodigos() {
    return leerCarrito().then(function (c) {
      if (c && c.discount_codes && c.discount_codes.length) {
        return fetch('/cart/update.js', { method: 'POST', headers: JSON_H, body: JSON.stringify({ discount: '' }) });
      }
    }).catch(function () {});
  }
  function vaciarCarrito() {
    return fetch('/cart/clear.js', { method: 'POST', headers: JSON_H }).catch(function () {}).then(quitarCodigos);
  }

  function volvioDeTarjeta() { try { return sessionStorage.getItem(MARCA) === '1'; } catch (e) { return false; } }
  function marcarTarjeta() { try { sessionStorage.setItem(MARCA, '1'); } catch (e) {} }
  function olvidarTarjeta() { try { sessionStorage.removeItem(MARCA); } catch (e) {} }

  function cantidadElegida() {
    var r = document.querySelector('[data-mt-paquete-radio]:checked');
    var n = parseInt(r ? r.getAttribute('data-cantidad') : '1', 10);
    return n >= 1 && n <= 3 ? n : 1;
  }

  /* ---------- Pago con tarjeta ---------- */
  function initTarjeta() {
    var b = boton();
    if (!b) return;
    var span = b.querySelector('span');
    var textoInicial = span ? span.textContent : b.textContent;
    var ocupado = false;
    function texto(t) { if (span) span.textContent = t; else b.textContent = t; }
    function reactivar() { ocupado = false; b.disabled = false; texto(textoInicial); }

    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (ocupado) return;
      ocupado = true;
      b.disabled = true;
      texto(b.getAttribute('data-texto-cargando') || 'Un momento…');
      var n = cantidadElegida();
      var codigo = (b.getAttribute('data-codigo-' + n) || '').trim();
      var url = '/cart/' + b.getAttribute('data-variante') + ':' + n + (codigo ? '?discount=' + encodeURIComponent(codigo) : '');
      marcarTarjeta();
      fetch('/cart/clear.js', { method: 'POST', headers: JSON_H })
        .catch(function () {})
        .then(function () { window.location.href = url; });
    }, true);

    window.addEventListener('pageshow', function (ev) { if (ev.persisted) reactivar(); });
  }

  /* ---------- Contraentrega (Releasit): sin códigos de tarjeta ---------- */
  function initContraentrega() {
    var permitir = false, trabajando = false;
    document.addEventListener('click', function (e) {
      if (permitir) return;
      var objetivo = e.target && e.target.closest ? e.target.closest('#rsi_buy_now_button') : null;
      if (!objetivo) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (trabajando) return;
      trabajando = true;
      function pasar() { permitir = true; objetivo.click(); permitir = false; trabajando = false; }
      quitarCodigos().then(pasar, pasar);
    }, true);
  }

  function iniciar() {
    if (!boton()) return;
    if (volvioDeTarjeta()) {
      /* Viene de un intento con tarjeta: vaciar y recargar UNA vez para que Releasit
         arranque con el carrito limpio (la marca se borra antes, no hay bucle). */
      olvidarTarjeta();
      vaciarCarrito().then(function () { window.location.reload(); });
      return;
    }
    quitarCodigos();
    initTarjeta();
    initContraentrega();
  }

  /* Volver con "atrás": la página estaba congelada → limpiar y recargar */
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted || !boton()) return;
    if (volvioDeTarjeta()) {
      olvidarTarjeta();
      vaciarCarrito().then(function () { window.location.reload(); });
    } else {
      quitarCodigos();
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
